import { createStyles, StylesClasses } from '@utils/styles'

const styles = createStyles({
  // Compact sidebar / mobile-style card (size="small")
  smallCard: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    width: '100%',
    padding: '20px 16px',
    borderRadius: '16px',
    backgroundColor: 'custom.creditCardBackground',
    boxShadow: 2,
    overflow: 'hidden',
  },
  smallHeading: {
    color: 'text.primaryDark',
  },
  smallDescription: {
    color: 'text.primaryDark',
  },
  smallForm: {
    width: '100%',
    mt: '4px',
    '& form': {
      flexDirection: 'column !important',
      width: '100%',
    },
    '& .MuiTextField-root': {
      width: '100%',
      minWidth: '0 !important',
    },
    '& .MuiButton-root': {
      width: '100%',
    },
  },
})

export type StylesClassNames = StylesClasses<typeof styles>

export default styles
